import React from 'react';

const LayoutRightBlock = (props) => {
  const { currentLayout: biggerLayout, handleSorting, handleLayout } = props;

  return (
    <div className='layout-right-block'>
   
      <select id='dropdown' onChange={handleSorting}>
        <option value='label asc'>Title Acsending</option>
        <option value='label desc'>Title Descending</option>
        <option value='price asc'>Price Ascending</option>
        <option value='price desc'>Price Descending</option>
      </select>

      <button
        className='layout'
        disabled={!biggerLayout}
        onClick={handleLayout}
      >
        <div className='four-layout'>
          <div className='inner-layout-top'>
            <div></div>
            <div></div>
          </div>
          <div className='inner-layout-bottom'>
            <div></div>
            <div></div>
          </div>
        </div>
      </button>

      <button className='layout' disabled={biggerLayout} onClick={handleLayout}>
        <div className='six-layout'>
          <div className='inner-layout-top'>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div className='inner-layout-bottom'>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </button>
    </div>
  );
};

export default LayoutRightBlock;
